import type { ReactNode } from 'react';
import type { TeamCapacitySummary } from '../hooks/useTeamCapacities';
import type { CalendarTeam } from './CalendarView';
import { GridTeamRow } from './GridTeamRow';

interface CalendarGridTeamRowsProps {
  teams: CalendarTeam[];
  selectedTeams: string[];
  teamFilter: string;
  weekDays: Date[];
  summariesByTeam: Map<string, TeamCapacitySummary>;
  renderCell: (team: CalendarTeam, day: Date) => ReactNode;
}

export function CalendarGridTeamRows({
  teams,
  selectedTeams,
  teamFilter,
  weekDays,
  summariesByTeam,
  renderCell,
}: CalendarGridTeamRowsProps) {
  const visibleTeams = teams.filter((team) => {
    if (selectedTeams.length > 0 && !selectedTeams.includes(team.id)) return false;
    if (teamFilter !== 'all' && team.id !== teamFilter) return false;
    return true;
  });

  if (visibleTeams.length === 0) return null;

  return (
    <>
      {visibleTeams.map((team) => (
        <GridTeamRow
          key={team.id}
          team={team}
          summary={summariesByTeam.get(team.id)}
          weekDays={weekDays}
          renderCell={renderCell}
        />
      ))}
    </>
  );
}
